module.exports = __webpack_public_path__ + "img/manda_031.0cef1d55.png";